import { OffersImageComponent } from './offers-image.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ OffersImage: OffersImageComponent });
